export const ModuleTypes = Object.freeze({
    HORECA: 1,
    TICKETING: 2,
    BOWLING: 106,
    ACTIVITIES: 161,
    WEBSHOP: 6,
    SALON: 7,
    APPOINTMENT: 8,
    HOTEL: 115,
  });

  export const STATUSTYPEIDS = Object.freeze({
    OPEN: 1,
  });

  
  